<template>
<!-- ============================================================== -->
<!-- Right sidebar -->
<!-- ============================================================== -->
<!-- .right-sidebar -->
  <div class="right-sidebar">
    <div class="slimscrollright">
      <div class="rpanel-title"> Chat <span><i class="ti-close right-side-toggle"></i></span> </div>
      <div class="r-panel-body">
      </div>
    </div>
  </div>
<!-- ============================================================== -->
<!-- End Right sidebar -->
<!-- ============================================================== -->

</template>

<script>
export default {
  name: 'right-sidebar',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/RightSidebar.vue